<script>
import { h } from "vue";
import { Link } from '@inertiajs/vue3'
export default {
    name: "EventCard",
    props: {
        event: Object,
    },
    render() {
        return h("div", { class: "w-full relative rounded-lg overflow-hidden hover:shadow-lg transition-all duration-300" },
            h(Link, { href: '/event/' + this.event.id, class: "block" }, [
                h("img", {
                    class: "object-cover h-64 w-full hover:scale-105 transition-all duration-300",
                    src: this.event.poster,
                    alt: this.event.name
                }),
                h("div", { class: 'absolute bottom-0 left-0 right-0 px-4 py-4 bg-gradient-to-t from-nomad-950 to-transparent text-left' }, [
                    h(
                        "h2",
                        { class: "text-lg font-semibold text-white truncate" },
                        this.event.name
                    ),
                    h("h3", { class: "text-md font-light text-nomad-300 mt-1" }, this.event.city),
                ]),
            ])
        );
    },
};
</script>
